import invSosLogo from '../../../../../../assets/img/corporacion-sos-logo.png'

export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 25
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const identifySelectedRequestType = (arraySubtypes, dataToSearch) => {
        const foundValue = arraySubtypes.find(item => item.idgestiontipo === dataToSearch)

        return (foundValue)? foundValue.prefijo : 'No se ha seleccionado nada'
    }

    const _drawHeaderLegalizationPaymentTicket = (docPdf, data, posY) => {
            
            // Marco 
            docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50
    
            // Logo
            const imgWidth = 60;
            const imgHeight = 30;
            docPdf.addImage(invSosLogo, 'PNG', 15, posY-15, imgWidth, imgHeight);
    
            // Membrete principal
            docPdf.setFont("helvetica", "bold");
            docPdf.setFontSize(titleFontSize);
            docPdf.text('INVERSIONES SOS S.A.', 140, posY, { align: 'center' }); // Centrado
            docPdf.setFontSize(defaultFontSize);
    
            posY += 5
    
            docPdf.setFont("helvetica", "normal");
            docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
            docPdf.text('TELEFONO: 2458-1568 EXTENSION 1', 140, posY+5, { align: 'center' });
    
            posY += 20
            
            // Fecha
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 35, 5, 'F');
            docPdf.rect(20, posY, 80, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('FECHA', 25, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_fecha_recibo, 60, posY+4, { align: 'left' });
            
            // Hora
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(100, posY, 35, 5, 'F');
            docPdf.rect(100, posY, 80, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('HORA', 110, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_hora_recibo, 140, posY+4, { align: 'left' });
            
            // Hora
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(180, posY, 35, 5, 'F');
            docPdf.rect(180, posY, 80, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('ESTADO', 185, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.aprobacion_check, 220, posY+4, { align: 'left' });
    
            posY += 10
    
            // Cliente
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 35, 5, 'F');
            docPdf.rect(20, posY, 160, 5); //240
            docPdf.setFont("helvetica", "bold");
            docPdf.text('CLIENTE', 25, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.datos_cliente, 58, posY+4, { align: 'left' });
            
            // Por
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(180, posY, 35, 5, 'F');
            docPdf.rect(180, posY, 80, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('POR Q', 185, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_quetzales.toLocaleString(), 220, posY+4, { align: 'left' });
            
            posY += 5
    
            // Concepto
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 35, 5, 'F');
            docPdf.rect(20, posY, 160, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('CONCEPTO', 25, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text('PAGO POR AMPLIACIÓN DE PLAZO', 58, posY+4, { align: 'left' });
            
            // Fecha de pago
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(180, posY, 35, 5, 'F');
            docPdf.rect(180, posY, 80, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('F. PAGO', 185, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            // docPdf.text(data.mes_a_pagar, 220, posY+4, { align: 'left' });
    
        }
    
        const _drawIdentifiersLegalizationPaymentTicket = (docPdf, data, posY) => {
    
            docPdf.setFont("helvetica", "bold");
            docPdf.setFontSize(defaultFontSize);
            docPdf.text(`CONTRATO ${data.contrato_codigo}`, 215, posY);
            docPdf.text(`RECIBO NO. ${data.idmovimiento}`, 215, posY+5);
    
        }
    
        const _drawInfoLegalizationPaymentTicket = (docPdf, data, posY) => {
    
            // Info Pago
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('TIPO', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_tipo, 45, posY+4, { align: 'left' });
    
            // Monto
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(67, posY, 23, 5, 'F');
            docPdf.rect(67, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('MONTO', 70, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_monto, 92, posY+4, { align: 'left' });
    
            posY += 5
    
            // Moneda
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('MONEDA', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_moneda, 45, posY+4, { align: 'left' });
    
            // Tipo cambio
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(67, posY, 23, 5, 'F');
            docPdf.rect(67, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('CAMBIO', 70, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_tipo_cambio, 92, posY+4, { align: 'left' });
            
            posY += 5
    
            // Total Queztales
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('TOTAL Q.', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_quetzales, 45, posY+4, { align: 'left' });
    
            // Total Dolares
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(67, posY, 23, 5, 'F');
            docPdf.rect(67, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('TOTAL $.', 70, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.movimiento_dolares, 92, posY+4, { align: 'left' });
            
            posY += 10
    
            // Cuenta
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 94, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('CAJA', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.descripcion_caja || '---', 45, posY+4, { align: 'left' });
    
            posY += 5
    
            // Cuenta
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 94, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('BANCO', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.descripcion_banco || '---', 45, posY+4, { align: 'left' });
            
            posY += 5
    
            // Numero de boleta
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(20, posY, 23, 5, 'F');
            docPdf.rect(20, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('BOLETA', 23, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.boleta_numero || '---', 45, posY+4, { align: 'left' });
    
            // Referencia ACH
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(67, posY, 23, 5, 'F');
            docPdf.rect(67, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('ACH', 70, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.aprobacion_referencia_ach || '---', 92, posY+4, { align: 'left' });
        }
    
        const _drawBalanceInfoLegalizationPaymentTicket = (docPdf, data, posY) => {
            
            // console.log('_drawBalanceInfoLegalizationPaymentTicket', data)
    
            // Alquiler
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(123, posY, 23, 5, 'F');
            docPdf.rect(123, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('COSTO', 126, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.legalizacion_monto, 148, posY+4, { align: 'left' });
    
            posY += 5
            
            // Exonerado
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(123, posY, 23, 5, 'F');
            docPdf.rect(123, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('EXONE.', 126, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.legalizacion_exoneracion, 148, posY+4, { align: 'left' });
    
            posY += 5
    
            // Recibido
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(123, posY, 23, 5, 'F');
            docPdf.rect(123, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('RECIBIDO', 126, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(data.total_recibido, 148, posY+4, { align: 'left' });
            
            posY += 5
    
            // Saldo
            docPdf.setFillColor(230, 230, 230); // RGB gris
            docPdf.rect(123, posY, 23, 5, 'F');
            docPdf.rect(123, posY, 47, 5);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('SALDO', 126, posY+4, { align: 'left' });
            docPdf.setFont("helvetica", "normal");
            docPdf.text(String(data.saldo_total), 148, posY+4, { align: 'left' });
    
        }
    
        const _drawObservationsLegalizationPaymentTicket = (docPdf, data, justifyTextBox, posY) => {
    
            // Info Pago
            docPdf.setFillColor(230, 230, 230); // RGB gris
            // docPdf.rect(20, posY, 35, 5, 'F');
            docPdf.rect(180, posY, 80, 70);
            docPdf.setFont("helvetica", "bold");
            docPdf.text('OBSERVACIONES', 183, posY+4, { align: 'left' });
            
            posY += 5
            docPdf.setFont("helvetica", "normal");
            justifyTextBox(docPdf, data.movimiento_observaciones || '', 181, posY+4, 90, {
                fontSize: defaultFontSize,
                fontName: 'helvetica',
                lineSpacing: 5
            })
    
            posY += 35
            docPdf.setFont("helvetica", "normal");
            justifyTextBox(docPdf, data.aprobacion_observaciones || '', 181, posY+4, 90, {
                fontSize: defaultFontSize,
                fontName: 'helvetica',
                lineSpacing: 5
            })
    
        }
    
        const _drawFooterLegalizationPaymentTicket = (docPdf, data, justifyTextBox, posY) => {
            
            docPdf.line(20, posY, 90, posY);
            docPdf.text('FIRMA AUTORIZADA', 40, posY+7, { align: 'left' });
            docPdf.text('SELLO', 125, posY+4, { align: 'left' });
    
            posY += 20
            docPdf.setFont("helvetica", "normal");
            const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
            justifyTextBox(docPdf, text, 20, posY, 240, {
                fontSize: defaultFontSize,
                fontName: 'helvetica',
                lineSpacing: 5
            })
        }
    
        const drawLegalizationPaymentTicket = (pdfManager, data) => {
            
            const { pdfLandscapeDoc, justifyTextBox } = pdfManager
    
            // console.log('drawLegalizationPaymentTicket ----- ', data)
    
            _drawHeaderLegalizationPaymentTicket(pdfLandscapeDoc, data, 30)
            _drawIdentifiersLegalizationPaymentTicket(pdfLandscapeDoc, data, 30)
            _drawInfoLegalizationPaymentTicket(pdfLandscapeDoc, data, 90)
            _drawBalanceInfoLegalizationPaymentTicket(pdfLandscapeDoc, data, 90)
            _drawObservationsLegalizationPaymentTicket(pdfLandscapeDoc, data, justifyTextBox, 90)
            _drawFooterLegalizationPaymentTicket(pdfLandscapeDoc, data, justifyTextBox, 155)
    
            pdfLandscapeDoc.save(`RECIBO LEGALIZACION AMPLIACIÓN ${data.contrato_codigo}.pdf`);
        }

    const getBodyForDateChange = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            // // datos globales
            idcontrato: FormRequestGlobal.formState.idcontrato,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            gestion_nuevo_dia_pago: FormRequestGlobal.formState.gestion_nuevo_dia_pago,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForDepositRefund = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcontrato: FormRequestGlobal.formState.idcontrato,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            monto_devolucion: FormRequestGlobal.formState.monto_devolucion,
            aprobacion_check: FormRequestGlobal.formState.aprobacion_check,
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }

    const getBodyForExtensionOfTerm = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcontrato: FormRequestGlobal.formState.idcontrato,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            meses_ampliacion: FormRequestGlobal.formState.meses_ampliacion,
            legalizacion_monto: FormRequestGlobal.formState.legalizacion_monto,
            legalizacion_exoneracion: FormRequestGlobal.formState.legalizacion_exoneracion,
            legalizacion_pago: FormRequestGlobal.formState.legalizacion_pago,
            aprobacion_check: 'Pendiente Contrato',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
    }

    const getGeneralLegalBody = ({user, FormRequestGlobal, isForUpdate}) => {
           
        const currentDate = getCurrentDate()

        const usuarioField = isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField = isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        return {
            idcontrato: FormRequestGlobal.formState.idcontrato,
            idgestiontipo: FormRequestGlobal.formState.idgestiontipo,
            gestion_fecha: currentDate,
            gestion_usuario: user.username,
            gestion_descripcion: FormRequestGlobal.formState.gestion_descripcion,
            ordinary_total_debt: FormRequestGlobal.formState.ordinary_total_debt,
            ordinary_total_exemption: FormRequestGlobal.formState.ordinary_total_exemption,
            ordinary_total_paid: FormRequestGlobal.formState.ordinary_total_paid,
            extraordinary_total_debt: FormRequestGlobal.formState.extraordinary_total_debt,
            extraordinary_total_exemption: FormRequestGlobal.formState.extraordinary_total_exemption,
            extraordinary_total_paid: FormRequestGlobal.formState.extraordinary_total_paid,
            expense_total_debt: FormRequestGlobal.formState.expense_total_debt,
            expense_total_exemption: FormRequestGlobal.formState.expense_total_exemption,
            expense_total_paid: FormRequestGlobal.formState.expense_total_paid,
            aprobacion_usuario: user.username,
            aprobacion_check: 'Aprobado',
            aprobacion_fecha : currentDate,
            [usuarioField]: user.username,
            [fechaField]: currentDate,
        }
        
    }
    
    return Object.freeze({
        identifySelectedRequestType,
        drawLegalizationPaymentTicket,
        getCurrentDate,
        getBodyForDateChange,
        getBodyForDepositRefund,
        getBodyForExtensionOfTerm,
        getGeneralLegalBody
    })
}